import { Component, Input, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { ProApproverDetailModel } from "src/app/model/ProApproverDetailModel";
import { ProApproverService } from "src/app/services/pro-approver.service";
// import { ViewPdfComponent } from "../view-pdf/view-pdf.component";
// import { ProRejectCaseComponent } from "./reject-case/pro-reject-case.component";
import {
  InAppBrowser,
  InAppBrowserEvent,
  InAppBrowserOptions,
} from "@awesome-cordova-plugins/in-app-browser/ngx";
import { ESignService } from "src/app/services/esign-service.service";
import { ApplicantDetailListModel } from "src/app/model/ApplicantDetailListModel";
import { RejectCaseComponent } from "../reject-case-modal/reject-case.component";
// import { ProApproveCaseComponent } from "./approve-case/pro-approve-case.component";

@Component({
  selector: "photo-upload",
  templateUrl: "./photo-upload.component.html",
  styleUrls: ["./photo-upload.component.scss"],
})
export class PhotoUploadComponent implements OnInit {
  isLoading: boolean = false;
  approverDetail: ApplicantDetailListModel;
  submitDisabled: boolean;
  newApplicantPhoto: string;
  selectedFileName: string;
  applicationNo: number;
  verificationStatus: string;
  @Input() key: number;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private proApproverService: ProApproverService,
    private iab: InAppBrowser,
    private esignService: ESignService,
    private modalCtrl: ModalController,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    // console.log("Where is Key", this.key);

    // this.submitDisabled = false;
    this.route.params.subscribe((params: Params) => {
      this.applicationNo = +params["applicationNo"];
      this.isLoading = true;
      this.proApproverService
        .fetchApplicantPhotoDetailBykey(this.key)
        .subscribe((data) => {
          this.approverDetail = data;
          this.newApplicantPhoto = data.newPhotoName;
          this.selectedFileName = data.selectedFileName;
          // console.log(this.applicationNo);

          this.isLoading = false;
        });
    });
  }

  async reject() {
    const modal = await this.modalCtrl.create({
      component: RejectCaseComponent,
      componentProps: {
        // pan: this.proApproverDetail.pan,
        // applicantName: this.proApproverDetail.applicantName,
      },
    });
    modal.present();
    const { data, role } = await modal.onWillDismiss();
    if (role === "reject") {
      this.onSubmit("REJECTED", data);
    }
  }

  async approve() {
    this.onSubmit("APPROVED", null);
  }

  onSubmit(statusType: string, rejectReason?: string) {
    this.isLoading = true;
    this.submitDisabled = true;
    this.proApproverService
      .submitVerificationDetailForApplicant(this.key, statusType, rejectReason)
      .subscribe(
        (data) => {
          if (data.status === "SUCCESS") {
            if (statusType === "APPROVED") {
              this.isLoading = false;
              this.proApproverService.successToast(
                "Applicant with Application Number - " +
                  this.applicationNo +
                  " has been Approved."
              );
              this.updateDetailsInApplicantTable();
              this.router.navigate([
                "/secure",
                "applicant-editing-approver-list",
              ]);
            } else {
              this.isLoading = false;
              this.proApproverService.successToast(
                "Applicant with Application Number -" +
                  this.approverDetail.applicationNo +
                  " has been Rejected."
              );
              this.router.navigate([
                "/secure",
                "applicant-editing-approver-list",
              ]);
            }
          } else {
            this.isLoading = false;
            this._snackBar.open(data.errorMessage, "Close", {
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: "warning-toast",
              duration: 3 * 1000,
            });
            this.submitDisabled = false;
          }
        },
        (error) => {
          this.submitDisabled = false;
          this.isLoading = false;
          this._snackBar.open(error.errorMessage, "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "warning-toast",
            duration: 3 * 1000,
          });
        }
      );
  }

  updateDetailsInApplicantTable() {
    this.isLoading = true;
    this.submitDisabled = true;
    this.proApproverService
      .updateDetailsInApplicantTable(
        this.applicationNo,
        "data:image/jpeg;base64," + this.newApplicantPhoto,
        this.selectedFileName
      )
      .subscribe(
        (data) => {
          if (data.status === "SUCCESS") {
            this.proApproverService.successToast(
              "Applicant Table Updated with Application Number " +
                this.applicationNo
            );
          } else {
            this.isLoading = false;
            this._snackBar.open(data.errorMessage, "Close", {
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: "warning-toast",
              duration: 3 * 1000,
            });
            this.submitDisabled = false;
          }
        },
        (error) => {
          this.submitDisabled = false;
          this.isLoading = false;
          this._snackBar.open(error.errorMessage, "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "warning-toast",
            duration: 3 * 1000,
          });
        }
      );
  }

  downloadFile(base64: string | ArrayBuffer, fileName: string) {
    const src = `data:application/pdf;base64,${base64}`;
    const link = document.createElement("a");
    link.href = src;
    link.download = fileName;
    link.click();

    link.remove();
  }

  async viewFile(fileType, file) {
    // const modal = await this.modalCtrl.create({
    //   component: ViewPdfComponent,
    //   componentProps: {
    //     base64: file,
    //     documentName: fileType,
    //     fileName:
    //       fileType +
    //       "_" +
    //       this.proApproverDetail?.pan +
    //       "_" +
    //       new Date().getTime() +
    //       ".pdf",
    //   },
    // });
    // modal.present();
  }
}
